import React from 'react';
import { motion } from 'framer-motion';
import { 
  SiJavascript, 
  SiMysql, 
  SiC, 
  SiPython, 
  SiHtml5, 
  SiCss3, 
  SiReact, 
  SiTailwindcss, 
  SiRedux, 
  SiGit, 
  SiGithub, 
  SiExpress 
} from 'react-icons/si';
import { FaJava } from 'react-icons/fa';

const TechStack = () => {
  const technologies = [
    { name: 'Java', icon: <FaJava className="w-8 h-8" />, color: 'text-red-600' },
    { name: 'JavaScript', icon: <SiJavascript className="w-8 h-8" />, color: 'text-yellow-500' },
    { name: 'SQL', icon: <SiMysql className="w-8 h-8" />, color: 'text-blue-600' },
    { name: 'C', icon: <SiC className="w-8 h-8" />, color: 'text-blue-700' },
    { name: 'Python', icon: <SiPython className="w-8 h-8" />, color: 'text-blue-500' },
    { name: 'HTML', icon: <SiHtml5 className="w-8 h-8" />, color: 'text-orange-500' },
    { name: 'CSS', icon: <SiCss3 className="w-8 h-8" />, color: 'text-blue-500' },
    { name: 'React.js', icon: <SiReact className="w-8 h-8" />, color: 'text-cyan-500' },
    { name: 'Tailwind CSS', icon: <SiTailwindcss className="w-8 h-8" />, color: 'text-teal-500' },
    { name: 'Redux Toolkit', icon: <SiRedux className="w-8 h-8" />, color: 'text-purple-600' },
    { name: 'MySQL', icon: <SiMysql className="w-8 h-8" />, color: 'text-blue-600' },
    { name: 'Git', icon: <SiGit className="w-8 h-8" />, color: 'text-orange-600' },
    { name: 'GitHub', icon: <SiGithub className="w-8 h-8" />, color: 'text-gray-800 dark:text-white' },
    { name: 'Express.js', icon: <SiExpress className="w-8 h-8" />, color: 'text-gray-700 dark:text-gray-300' }
  ];

  return (
    <div className="mt-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center mb-12"
      >
        <h3 className="text-3xl font-bold mb-4">Tech Stack</h3>
        <p className="text-lg text-gray-600 dark:text-gray-300">
          Technologies I work with
        </p>
      </motion.div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-6">
        {technologies.map((tech, index) => (
          <motion.div
            key={tech.name}
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ scale: 1.15, y: -8, rotateY: 15 }}
            className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-xl p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-white/30 dark:border-gray-700/50 flex flex-col items-center group transform-gpu"
          >
            <motion.div 
              className={`${tech.color} mb-4`}
              whileHover={{ 
                rotate: [0, -20, 20, -15, 15, 0],
                scale: [1, 1.4, 1.3, 1.35, 1.2],
                y: [0, -8, 8, -5, 0]
              }}
              transition={{ duration: 1, ease: "easeInOut" }}
            >
              {tech.icon}
            </motion.div>
            <span className="text-sm font-medium text-center">{tech.name}</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TechStack;